import { lastElement, maxByKey, minByKey } from "./array";
const DEFAULT_SUMMARY_METRIC = "latest";
/**
 * Given a TimeSeries, get the summary value based on the users preference in local storage
 * @param series
 */
export function getSummaryMetricValue(series) {
    let summary = DEFAULT_SUMMARY_METRIC;
    const summaryLocal = localStorage.getItem("charts-summary-metric");
    if (summaryLocal !== null) {
        summary = JSON.parse(summaryLocal);
    }
    switch (summary) {
        case "latest": {
            const latest = lastElement(series.data);
            if (latest && latest.y !== null) {
                return Number(latest.y);
            }
            return series.stat; // use aggregate as a fallback
        }
        case "maximum": {
            const max = maxByKey(series.data, "y");
            if (max.y !== null) {
                return max.y;
            }
            else {
                return 0;
            }
        }
        case "minimum": {
            const min = minByKey(series.data, "y");
            if (min.y !== null) {
                return min.y;
            }
            return 0;
        }
        default:
            return series.stat;
    }
}
/**
 * Given a TimeSeries, generate the summary metric help text based on the users preference in local storage
 * @param series
 */
export function getSummaryMetricHelpTextTimeSeries(series) {
    let summary = DEFAULT_SUMMARY_METRIC;
    const summaryLocal = localStorage.getItem("charts-summary-metric");
    if (summaryLocal !== null) {
        summary = JSON.parse(summaryLocal);
    }
    //Present the correct stat value in the help text.
    let stat = "75th percentile";
    switch (series.statId) {
        case 95:
            stat = "95th percentile";
            break;
        case 75:
            stat = "75th percentile";
            break;
        case 50:
            stat = "median";
            break;
        case "average":
            stat = "average";
            break;
    }
    const metricName = series.shortName ? series.shortName : series.name;
    //For count based metrics we are not accounting for a stat value so we show a different metric.
    if (series.metricType === "count") {
        switch (summary) {
            case "latest": {
                return `The latest of the "${metricName}" values plotted in the chart below`;
            }
            case "maximum": {
                return `The maximum of the "${metricName}" values plotted in the chart below`;
            }
            case "minimum": {
                return `The minimum of the "${metricName}" values plotted in the chart below`;
            }
            default:
                return `Total "${metricName}" in the time period`;
        }
    }
    switch (summary) {
        case "latest": {
            return `The latest of the ${stat} "${metricName}" values plotted in the chart below`;
        }
        case "maximum": {
            return `The maximum of the ${stat} "${metricName}" values plotted in the chart below`;
        }
        case "minimum": {
            return `The minimum of the ${stat} "${metricName}" values plotted in the chart below`;
        }
        default:
            return `The ${stat} "${metricName}" value in the time period`;
    }
}
/**
 * Given a Timeseries, generate the summary metric help text that is relevant for a value chart
 * @param series
 */
export function getSummaryMetricHelpTextValueChart(series) {
    //Present the correct stat value in the help text.
    let stat = "75th percentile";
    switch (series.statId) {
        case 95:
            stat = "95th percentile";
            break;
        case 75:
            stat = "75th percentile";
            break;
        case 50:
            stat = "median";
            break;
        case "average":
            stat = "average";
            break;
    }
    const metricName = series.shortName ? series.shortName : series.name;
    //For count based metrics we are not accounting for a stat value so we show a different metric.
    if (series.metricType === "count") {
        return `Total "${metricName}" in the time period`;
    }
    else {
        return `The ${stat} "${metricName}" value in the time period`;
    }
}
